import React from 'react'
import Box from '@fuegokit/react/components/Box'
import {LabelTextProps} from './types'

const labelTextStyles = {
  alignSelf: 'center',
  gridArea: '1 / 2 / 2 / 3'
}

export const AtlasLabelText = ({testId, children}: LabelTextProps) => {
  return (
    <Box as="span" sx={labelTextStyles} data-testid={testId ? `${testId}-checkbox-label` : undefined}>
      {children}
    </Box>
  )
}

const requiredIndicatorStyles = {
  paddingLeft: '2px',
  color: 'text.danger.default'
}

export const RequiredIndicator = () => {
  return (
    <Box as="span" sx={requiredIndicatorStyles} aria-hidden>
      *
    </Box>
  )
}
